var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box, Button, Flex, Icon, Input, Text } from '@chakra-ui/react';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { observer } from 'mobx-react';
import React from 'react';
import { AppColor, FontSize } from '../const/AppDefaults';
import { StoreContext } from '../uistore/Rootstore';
import DatePicker from "react-datepicker";
let AddEventDialog = class AddEventDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.addEventStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.addEventStore.dragging) {
                // lets move this dialog 
                rstore.addEventStore.setTop(e.clientY - this.adjusty);
                rstore.addEventStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    render() {
        const rstore = this.context;
        if (!rstore.addEventStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-chooser": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.addEventStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-chooser")) {
                    rstore.addEventStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.addEventStore.left + "px", top: rstore.addEventStore.top + "px", width: rstore.addEventStore.width + "px", height: (rstore.addEventStore.height) + "px" },
            React.createElement(Flex, { "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-chooser": 'colorbox', height: "35px", width: '100%' },
                React.createElement(Text, { "object-chooser": 'colorbox', ml: '5px', fontWeight: 'bold', color: AppColor.LinkNameColor, fontSize: FontSize.LinkName, w: '90%' }, "Add New Event"),
                React.createElement(Flex, { "object-chooser": 'colorbox', w: '10%', justify: 'flex-end' },
                    React.createElement(Icon, { "object-chooser": 'colorbox', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                            rstore.addEventStore.setShow(false);
                        }, className: 'message-option-button' }))),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Title', defaultValue: rstore.addEventStore.eventname, onChange: (e) => {
                    rstore.addEventStore.setEventName(e.currentTarget.value);
                } }),
            React.createElement(Flex, { w: '80%', m: '10px', align: 'center' },
                React.createElement(Text, { color: AppColor.InputLabelColor, fontSize: FontSize.InputLabel, mr: '5px' }, "Start"),
                React.createElement(DatePicker, { showTimeInput: true, dateFormat: "dd/MM/yyyy HH:mm", selected: rstore.addEventStore.startdate > -1 ? new Date(rstore.addEventStore.startdate) : new Date(), onChange: (date) => rstore.addEventStore.setStartDate(date.getTime()) }),
                React.createElement(Text, { color: AppColor.InputLabelColor, fontSize: FontSize.InputLabel, mr: '10px', ml: '5px' }, "End"),
                React.createElement(DatePicker, { showTimeInput: true, dateFormat: "dd/MM/yyyy HH:mm", selected: rstore.addEventStore.enddate > -1 ? new Date(rstore.addEventStore.enddate) : new Date(), onChange: (date) => rstore.addEventStore.setEndDate(date.getTime()) })),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Venue', defaultValue: rstore.addEventStore.location, onChange: (e) => {
                    rstore.addEventStore.setLocation(e.currentTarget.value);
                } }),
            React.createElement(Box, { w: '80%', m: '10px' },
                React.createElement(Button, { variant: 'unstyled' }, "Add Link")),
            React.createElement(Box, { w: '80%', m: '10px' },
                React.createElement(Button, { variant: 'unstyled' }, "Add Attachment")),
            React.createElement(Box, { w: '80%', m: '10px' },
                React.createElement(Button, { variant: 'unstyled' }, "Add People")),
            React.createElement(Box, { w: '80%', m: '10px' },
                React.createElement(Button, { variant: 'unstyled' }, "Add Notification")),
            React.createElement(Box, { w: '80%', m: '10px' }));
    }
};
AddEventDialog.contextType = StoreContext;
AddEventDialog = __decorate([
    observer
], AddEventDialog);
export { AddEventDialog };
